import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Filter.css';
import Input from '../../components/UI/Input/Input';


class Filter extends Component {
    state = {
        filterSelected: false
    }

    filterSelected = ( event ) => {
        this.props.filterChanged(event.target.value);       
    }

    render () {
        return (
        <Input
        key='filter'
        elementType='input'
        elementConfig={{
            type: 'text',
            placeholder: 'Filter Results'
        }}
        value={this.props.value}
        hasFocus='true'
        changed={this.filterSelected} />
        )
    }
};



export default Filter;


// WEBPACK FOOTER //
// ./src/components/Filter/Filter.js